import heroBg from "@/assets/subpage-hero-bg.webp";

interface SubpageHeroProps {
  title: string;
  subtitle: string;
}

const SubpageHero = ({ title, subtitle }: SubpageHeroProps) => {
  return (
    <section className="relative pt-32 pb-14 md:pt-36 md:pb-20 overflow-hidden">
      {/* Background Image */}
      <img
        src={heroBg}
        alt=""
        className="absolute inset-0 w-full h-full object-cover"
        aria-hidden="true"
      />
      {/* Bordeaux Overlay */}
      <div className="absolute inset-0 bg-primary/85" />

      {/* Content */}
      <div className="hotel-container text-center relative z-10">
        <p className="hotel-caption text-accent mb-4 tracking-[0.3em]">
          {subtitle}
        </p>
        <h1 className="font-display text-3xl md:text-4xl lg:text-5xl font-light text-primary-foreground leading-tight">
          {title}
        </h1>
        <div className="flex items-center justify-center gap-3 mt-6">
          <span className="w-10 h-px bg-accent" />
          <span className="w-1.5 h-1.5 rotate-45 border border-accent" />
          <span className="w-10 h-px bg-accent" />
        </div>
      </div>
    </section>
  );
};

export default SubpageHero;
